import React from 'react';
import { connect } from 'react-redux';
import { RootDispatch } from '../store';
import { ReactComponent as ProviderIcon } from '../PatientCall/images/provider.svg';
import { ReactComponent as AcceptIcon } from '../PatientCall/images/video-on.svg';
import { ReactComponent as DeclineIcon } from '../images/x-icon.svg';
import { CallEvent } from '../types';
import { dateToHourMinMeridiem } from '../util';
import styles from './IncomingCall.module.css';

export function IncomingCall({
  acceptCall,
  callEvent,
  declineCall,
}: {
  acceptCall: () => void;
  callEvent: CallEvent;
  declineCall: () => void;
}) {
  const callDate = new Date(callEvent.payload.date);
  const expiresAt = callEvent.ttl !== -1 && new Date(callDate.valueOf() + callEvent.ttl * 1000);
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <ProviderIcon height="49px" />
        <div className={styles.provider}>{callEvent.payload.name}</div>
        Invited you to join a {callEvent.payload.isVideo && 'video'} call
        <div className={styles.buttons}>
          <button className={styles.red} onClick={declineCall}>
            <DeclineIcon />
            <div>Decline</div>
          </button>
          <button className={styles.green} onClick={acceptCall}>
            <AcceptIcon height="21px" />
            <div>Accept</div>
          </button>
        </div>
        <div className={styles.info}>
          <div>{dateToHourMinMeridiem(callDate)}</div>
          <div>{expiresAt ? `Invitation expires at ${dateToHourMinMeridiem(expiresAt)}` : ' '}</div>
        </div>
      </div>
    </div>
  );
}

const mapDispatch = ({ call: { acceptCall, declineCall } }: RootDispatch) => ({
  acceptCall,
  declineCall,
});

// https://tigertext.atlassian.net/browse/TMG-837
// @ts-expect-error
export default connect(null, mapDispatch)(IncomingCall);
